import React from 'react';
import AnimationButton from './TopSection/AnimationButton';
import CenterButton from './TopSection/CenterButton';
import ContentButton from './TopSection/ContentButton';

function TopSection() {
  return (
    <div id="TopSection" className='absolute top-0 flex justify-between p-4 w-full gap-2 z-40'>
      <AnimationButton />
      <CenterButton />
      <ContentButton />
    </div>
  );
}

export default TopSection;